<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container-fluid dashboard-default-sec">
      <div class="row">
        <div class="col-xl-5 box-col-12 des-xl-100">
          <div class="row">
            <div class="col-xl-12 col-md-6 box-col-6 des-xl-50">
              <div class="card">
                <div class="card-body text-center">
                  <h3>
                    {{ h <= 10 ? this.$t("salutation_good_morning") : h >= 17 ? this.$t("salutation_good_evening") : this.$t("salutation_hello") }}
                    {{
                      $user != null
                        ? $user.firstname + " " + $user.lastname
                        : ""
                    }}
                  </h3>
                  <p>
                    {{
                      $t("yesterday_impressions", {
                        impressions: simpleStats.yesterdayViews,
                      })
                    }}
                  </p>
                  <a
                    class="btn btn-primary-light"
                    @click="$router.push('advertisements')"
                    >{{ $t("my_ads") }}</a
                  >
                </div>
              </div>
            </div>
            <div
              class="col-xl-6 col-md-3 col-sm-6 box-col-3 des-xl-25 rate-sec"
            >
              <div class="card income-card">
                <div class="card-body text-center">
                  <div
                    class="round-box"
                    v-bind:class="{
                      primary: simpleStats.deltaLastWeekViews > 0,
                      'bg-error': simpleStats.deltaLastWeekViews < 0,
                    }"
                  >
                    <div style="padding-left: 7px">
                      <i
                        style="font-size: 32px"
                        v-bind:class="{
                          toprightarrow: simpleStats.deltaLastWeekViews > 0,
                          bottomrightarrow: simpleStats.deltaLastWeekViews < 0,
                          rightarrow: simpleStats.deltaLastWeekViews == 0,
                        }"
                        class="fas fa-arrow-up me-2"
                      ></i>
                    </div>
                  </div>
                  <h5>{{ simpleStats.lastWeekViews }}</h5>
                  <p>{{ $t("impressions_in_a_week") }}</p>
                  <a
                    class="btn-arrow"
                    style="color: #444 !important"
                    v-bind:class="{
                      'arrow-primary': simpleStats.deltaLastWeekViews > 0,
                      'error-color': simpleStats.deltaLastWeekViews < 0,
                    }"
                    href="javascript:void(0)"
                    ><i
                      v-bind:class="{
                        toprightarrow: simpleStats.deltaLastWeekViews > 0,
                        bottomrightarrow: simpleStats.deltaLastWeekViews < 0,
                        rightarrow: simpleStats.deltaLastWeekViews == 0,
                      }"
                      style="color: #444 !important"
                      class="fa fa-arrow-up me-2"
                    ></i
                    >{{
                      simpleStats.deltaLastWeekViews == "Infinity"
                        ? "∞"
                        : simpleStats.deltaLastWeekViews
                    }}% {{ $t("more_than_before") }}</a
                  >
                </div>
              </div>
            </div>
            <div
              class="col-xl-6 col-md-3 col-sm-6 box-col-3 des-xl-25 rate-sec"
            >
              <div class="card income-card">
                <div class="card-body text-center">
                  <div
                    class="round-box"
                    v-bind:class="{
                      primary: simpleStats.deltaLastWeekClicks > 0,
                      'bg-error': simpleStats.deltaLastWeekClicks < 0,
                    }"
                  >
                    <div style="padding-left: 7px">
                      <i
                        style="font-size: 32px"
                        v-bind:class="{
                          toprightarrow: simpleStats.deltaLastWeekClicks > 0,
                          bottomrightarrow: simpleStats.deltaLastWeekClicks < 0,
                          rightarrow: simpleStats.deltaLastWeekClicks == 0,
                        }"
                        class="fas fa-arrow-up me-2"
                      ></i>
                    </div>
                  </div>
                  <h5>{{ simpleStats.lastWeekClicks }}</h5>
                  <p>{{ $t("clicks_in_a_week") }}</p>
                  <a
                    class="btn-arrow"
                    style="color: #444 !important"
                    v-bind:class="{
                      'arrow-primary': simpleStats.deltaLastWeekClicks > 0,
                      'error-color': simpleStats.deltaLastWeekClicks < 0,
                    }"
                    href="javascript:void(0)"
                    ><i
                      v-bind:class="{
                        toprightarrow: simpleStats.deltaLastWeekClicks > 0,
                        bottomrightarrow: simpleStats.deltaLastWeekClicks < 0,
                        rightarrow: simpleStats.deltaLastWeekClicks == 0,
                      }"
                      style="color: #444 !important"
                      class="fa fa-arrow-up me-2"
                    ></i
                    >{{
                      simpleStats.deltaLastWeekClicks == "Infinity"
                        ? "∞"
                        : Math.round(simpleStats.deltaLastWeekClicks * 100) / 100
                    }}% {{ $t("more_than_before") }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-7 box-col-12 des-xl-100 dashboard-sec">
          <div class="card income-card">
            <div class="card-header">
              <div class="header-top d-sm-flex align-items-center">
                <h5>{{ $t("impressions_and_clicks") }}</h5>
                <div class="center-content">
                  <p class="d-sm-flex align-items-center">
                    <span class="font-primary m-r-10 f-w-700"
                      >{{ simpleStats.activeAds }} {{ $t("active_ads") }}</span
                    >
                  </p>
                </div>
              </div>
            </div>
            <div class="card-body p-0" style="height: 400px">
              <apexcharts
                v-if="impressionsDiagramLoaded"
                height="100%"
                :options="impressionsOverviewOptions"
                :series="impressionsOverviewOptions.series"
              ></apexcharts>
              <div id="chart-timeline-dashbord"></div>
              <!-- <div v-show="newestCases.length == 0" style="position: absolute; top: 100px; width: 100%; text-align: center;">
                    Es wurden noch keine Fälle gemeldet.
                  </div> -->
            </div>
          </div>
        </div>
        <div class="col-xl-12 box-col-12 des-xl-100">
          <div class="row">
            <div class="col-xl-6 box-col-12 des-xl-100 dashboard-sec">
              <div class="card income-card">
                <div class="card-header">
                  <div class="header-top d-sm-flex align-items-center">
                    <h5>{{ $t("impressions_comparison_by_ad") }}</h5>
                    <div class="center-content">
                      <p class="d-sm-flex align-items-center">
                        <span class="font-primary m-r-10 f-w-700"
                          >{{ simpleStats.activeAds }} {{ $t("active_ads") }}</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
                <div class="card-body p-0" style="height: 400px">
                  <apexcharts
                    v-if="impressionsComparisonDiagramLoaded"
                    height="100%"
                    :options="impressionsComparisonOverviewOptions"
                    :series="impressionsComparisonOverviewOptions.series"
                  ></apexcharts>
                  <div id="chart-timeline-dashbord"></div>
                  <!-- <div v-show="newestCases.length == 0" style="position: absolute; top: 100px; width: 100%; text-align: center;">
                        Es wurden noch keine Fälle gemeldet.
                      </div> -->
                </div>
              </div>
            </div>
            <div class="col-xl-6 box-col-12 des-xl-100 dashboard-sec">
              <div class="card income-card">
                <div class="card-header">
                  <div class="header-top d-sm-flex align-items-center">
                    <h5>{{ $t("clicks_comparison_by_ad") }}</h5>
                    <div class="center-content">
                      <p class="d-sm-flex align-items-center">
                        <span class="font-primary m-r-10 f-w-700"
                          >{{ simpleStats.activeAds }} {{ $t("active_ads") }}</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
                <div class="card-body p-0" style="height: 400px">
                  <apexcharts
                    v-if="clicksComparisonDiagramLoaded"
                    height="100%"
                    :options="clicksComparisonOverviewOptions"
                    :series="clicksComparisonOverviewOptions.series"
                  ></apexcharts>
                  <div id="chart-timeline-dashbord"></div>
                  <!-- <div v-show="newestCases.length == 0" style="position: absolute; top: 100px; width: 100%; text-align: center;">
                        Es wurden noch keine Fälle gemeldet.
                      </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-12 box-col-12 des-xl-100">
          <div class="row">
            <div class="col-xl-12 col-100 box-col-12 des-xl-100">
              <div class="card latest-update-sec">
                <div class="card-header">
                  <div class="header-top d-sm-flex align-items-center">
                    <h5>{{ $t("active_ads") }} ({{ activeAds.length }})</h5>
                    <!-- <div class="center-content">
                          <ul class="week-date">
                            <li class="font-primary">Heute</li>
                            <li>Monat</li>
                          </ul>
                        </div> -->
                  </div>
                </div>
                <div class="card-body">
                  <div v-show="activeAds.length == 0">
                    {{ $t("no_active_ads") }}
                  </div>
                  <div class="table-responsive">
                    <table class="table table-bordernone">
                      <tbody>
                        <tr v-for="ad in activeAds" :key="ad.id">
                          <td class="align-middle">
                            <v-img class="rounded-lg" :src="`/files/images/${ad.appImage}`" width="50" :aspect-ratio="1"></v-img>
                          </td>
                          <td>
                            <div class="media">
                              <div class="media-body">
                                <span
                                  style="
                                    display: inline-block;
                                    width: 250px;
                                    white-space: nowrap;
                                    overflow: hidden !important;
                                    text-overflow: ellipsis;
                                  "
                                  >{{ ad.name }}</span
                                >
                                <p v-show="ad.startDate != null && ad.endDate != null">{{ $formatDateTime(ad.startDate) }} - {{ $formatDateTime(ad.endDate) }}</p>
                              </div>
                            </div>
                          </td>
                          <td style="text-align: center; padding-top: 17px">
                            {{ ad.totalImpressions }} {{ ad.totalImpressions == 1 ? $t("impression") : $t("impressions") }}
                          </td>
                          <td style="text-align: center; padding-top: 17px">
                            {{ ad.totalClicks }} {{ ad.totalClicks == 1 ? $t("click") : $t("clicks") }}
                          </td>
                          <td style="text-align: center; padding-top: 17px">
                            {{ $formatCurrency(ad.biddingCPM) }}€/{{ $formatCurrency(ad.cpmPrice) }}€ 
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon size="16" v-on="on">fa fa-info-circle</v-icon>
                              </template>
                              <span>{{ $t('bidding_cpm') }}/{{ $t('calculated_cpm') }}<br>{{ $t("bidding_cpm_explanation") }}</span>
                            </v-tooltip>
                          </td>
                          <td style="text-align: center; padding-top: 17px">
                            {{ $formatCurrency(ad.totalBudget) }}€ {{ $t("payed") }}
                          </td>
                          <td style="text-align: center; padding-top: 15px">
                            <span class="badge badge-info" style="font-size: 10px">{{ ad.placementName }}</span>
                          </td>
                          <td>
                            <a href="javascript:void(0)" @click="$router.push('/edit-advertisement?advertisementId=' + ad.id)">{{ $t("details") }}</a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="code-box-copy">
                    <button
                      class="code-box-copy__btn btn-clipboard"
                      data-clipboard-target="#latest-update-sec"
                      title="Copy"
                    >
                      <i class="icofont icofont-copy-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {
  SettingsIcon,
  LogOutIcon,
  HomeIcon,
  AlignCenterIcon,
  AlertCircleIcon,
  ClipboardIcon,
  UsersIcon,
  CopyIcon,
  MaximizeIcon,
  StarIcon,
  BellIcon,
  MessageSquareIcon,
  GridIcon,
  BriefcaseIcon,
} from "vue-feather-icons";

export default {
  components: {
    apexcharts: VueApexCharts,
    SettingsIcon,
    LogOutIcon,
    HomeIcon,
    AlignCenterIcon,
    ClipboardIcon,
    UsersIcon,
    CopyIcon,
    MaximizeIcon,
    StarIcon,
    BellIcon,
    MessageSquareIcon,
    GridIcon,
    BriefcaseIcon,
    AlertCircleIcon,
  },
  data() {
    var _this = this;
    return {
      showPassword: false,

      salutation: "Guten Tag",
      newestCases: [],
      casesWithDeadlines: [],
      impressionsDiagramLoaded: false,
      impressionsComparisonDiagramLoaded: false,
      clicksComparisonDiagramLoaded: false,

      impressionsOverviewOptions: {
        series: [
          {
            name: "Impressions and Clicks",
            data: [],
          },
        ],
        colors: ["#2F3452", "#4FA4BA"],
        chart: {
          id: "area-datetime",
          type: "area",
          height: "100%",
          zoom: {
            autoScaleYaxis: true,
          },
          toolbar: {
            show: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: "hollow",
        },
        xaxis: {
          type: "datetime",
          min: new Date("01 01 2023").getTime(),
          tickAmount: 6,
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        tooltip: {
          x: {
            format: "dd.MM.yyyy HH:mm",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100],
          },
        },
      },

      impressionsComparisonOverviewOptions: {
        series: [
          {
            name: "Impressions",
            data: [],
          },
        ],
        colors: ["#2F3452", "#4FA4BA", "#91C94B", "#5E3139", "#AB4AC7", "#573669", "#4DD180", "#366569", "#4D51D1", "#32613E"],
        chart: {
          id: "area-datetime",
          type: "area",
          height: "100%",
          zoom: {
            autoScaleYaxis: true,
          },
          toolbar: {
            show: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: "hollow",
        },
        xaxis: {
          type: "datetime",
          min: new Date("01 01 2023").getTime(),
          tickAmount: 6,
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        tooltip: {
          x: {
            format: "dd.MM.yyyy HH:mm",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100],
          },
        },
      },

      clicksComparisonOverviewOptions: {
        series: [
          {
            name: "Clicks",
            data: [],
          },
        ],
        colors: ["#2F3452", "#4FA4BA", "#91C94B", "#5E3139", "#AB4AC7", "#573669", "#4DD180", "#366569", "#4D51D1", "#32613E"],
        chart: {
          id: "area-datetime",
          type: "area",
          height: "100%",
          zoom: {
            autoScaleYaxis: true,
          },
          toolbar: {
            show: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: "hollow",
        },
        xaxis: {
          type: "datetime",
          min: new Date("01 01 2023").getTime(),
          tickAmount: 6,
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        tooltip: {
          x: {
            format: "dd.MM.yyyy HH:mm",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100],
          },
        },
      },

      userOverviewOptions: {
        options: {
          series: [100, 18, 54, 12],
          chart: {
            height: 150,
            width: 150,
            type: "radialBar",
            toolbar: {
              show: true,
            },
          },
          plotOptions: {
            radialBar: {
              offsetY: 0,
              startAngle: 0,
              endAngle: 270,
              hollow: {
                margin: 5,
                size: "30%",
                background: "transparent",
                image: undefined,
              },
              colors: {
                backgroundBarColors: ["#e5edef"],
                backgroundBarOpacity: 1,
                backgroundBarRadius: 0,
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  show: false,
                },
              },
            },
          },
          colors: ["#24695C", "#BA895D"],
          labels: [
            "Alle Fälle",
            "Neue Fälle",
            "Abgeschlossene Fälle",
            "Abgelehnte Fälle",
          ],
          legend: {
            show: true,
            floating: true,
            fontSize: "16px",
            position: "left",
            offsetX: 5,
            offsetY: 15,
            labels: {
              useSeriesColors: true,
            },
            formatter: function (seriesName, opts) {
              // return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
              if (_this.otherStats.length == 0) return seriesName;
              return seriesName + ":  " + _this.otherStats[opts.seriesIndex];
            },
            markers: {
              size: 0,
            },
            itemMargin: {
              vertical: 3,
            },
          },
        },
      },

      credentials: {
        mail: "",
        password: "",
      },

      simpleStats: {
        yesterdayViews: 0,
        yesterdayClicks: 0,
        lastWeekViews: 0,
        lastWeekClicks: 0,
      },

      activeAds: [],
      h:0,

      otherStats: [],
    };
  },

  mounted() {
    const now = new Date();
    this.h = now.getHours();
    // this.salutation = h <= 12 ? this.$t("salutation_good_morning") : h >= 17 ? this.$t("salutation_good_evening") : this.$t("salutation_hello");
    this.fetchSimpleStats();
    this.fetchActiveAds();
    this.fetchImpressionsDiagramData();
    this.fetchImpressionsComparisonDiagramData();
    this.fetchClicksComparisonDiagramData();
  },

  methods: {
    logError(error) {
      console.log(error);
    },

    fetchSimpleStats() {
      var _this = this;
      this.$axios
        .get("/api/dashboard/general")
        .then(function (response) {
          _this.simpleStats = response.data;
        })
        .catch(this.onError);
    },

    fetchActiveAds() {
      var _this = this;
      this.$axios
        .get("/api/dashboard/activeAds")
        .then(function (response) {
          _this.activeAds = response.data;
        })
        .catch(this.onError);
    },

    fetchImpressionsDiagramData() {
      var _this = this;
      this.$axios
        .get("/api/dashboard/diagram/impressions")
        .then(function (response) {
          setTimeout(function () {
            _this.impressionsOverviewOptions.series = [
              {
                name: _this.$t("impressions"),
                data: response.data.impressions,
              },
              {
                name: _this.$t("clicks"),
                data: response.data.clicks,
              },
            ];
            if (response.data.impressions.length > 0) {
              _this.impressionsOverviewOptions.xaxis.min = response.data.impressions[0][0];
            }
            _this.impressionsDiagramLoaded = true;
            _this.$forceUpdate();
          }, 500);
        })
        .catch(this.onError);
    },

    fetchImpressionsComparisonDiagramData() {
      var _this = this;
      this.$axios
        .get("/api/dashboard/diagram/impressions-comparison")
        .then(function (response) {
          setTimeout(function () {
            _this.impressionsComparisonOverviewOptions.series = [];
            var minValue = -1;
            for (const [key, value] of Object.entries(response.data)) {
              _this.impressionsComparisonOverviewOptions.series.push({
                name: key,
                data: value
              });
              if(value.length > 0){
                minValue = minValue < 0 || value[0][0] < minValue ? value[0][0] : minValue;
              }
            }
            if (minValue > 0) {
              _this.impressionsComparisonOverviewOptions.xaxis.min = minValue;
            }
            _this.impressionsComparisonDiagramLoaded = true;
            _this.$forceUpdate();
          }, 500);
        })
        .catch(this.onError);
    },

    fetchClicksComparisonDiagramData() {
      var _this = this;
      this.$axios
        .get("/api/dashboard/diagram/clicks-comparison")
        .then(function (response) {
          setTimeout(function () {
            _this.clicksComparisonOverviewOptions.series = [];
            var minValue = -1;
            for (const [key, value] of Object.entries(response.data)) {
              _this.clicksComparisonOverviewOptions.series.push({
                name: key,
                data: value
              });
              if(value.length > 0){
                minValue = minValue < 0 || value[0][0] < minValue ? value[0][0] : minValue;
              }
            }
            if (minValue > 0) {
              _this.clicksComparisonOverviewOptions.xaxis.min = minValue;
            }
            _this.clicksComparisonDiagramLoaded = true;
            _this.$forceUpdate();
          }, 500);
        })
        .catch(this.onError);
    },

    fetchCaseStats() {
      var _this = this;
      this.$axios
        .get("/api/case/stats")
        .then(function (response) {
          setTimeout(function () {
            _this.otherStats = [
              response.data.ALL_COUNT,
              response.data.CREATED_COUNT,
              response.data.FINISHED_COUNT,
              response.data.REJECTED_COUNT,
            ];
            if (response.data.ALL_COUNT == 0) {
              _this.userOverviewOptions.options.series = [0, 0, 0, 0];
              return;
            }
            _this.userOverviewOptions.options.series = [
              100,
              (response.data.CREATED_COUNT / response.data.ALL_COUNT) * 100,
              (response.data.FINISHED_COUNT / response.data.ALL_COUNT) * 100,
              (response.data.REJECTED_COUNT / response.data.ALL_COUNT) * 100,
            ];
            console.log(_this.userOverviewOptions.options.series);
            _this.$forceUpdate();
          }, 500);
        })
        .catch(this.onError);
    },
  },
};
</script>

<style>
</style>